import { HubspotSourceType } from './cancellations';
import { AccountsTag } from './generalContent';
import { StreamChannelType } from './stream';

export enum AccountRole {
  Member = 'member',
  Leader = 'group_leader',
  Admin = 'admin',
  CommunityLeader = 'community_leader',
  PeerGf = 'peer_group_leader',
}

export enum AccountStatus {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export enum AccountFollowerStatus {
  Active = 'active',
  Inactive = 'inactive',
}

export enum AccountPaymentStatus {
  Free = 'free',
  Paying = 'paying',
  Cancelled = 'cancelled',
  Undefined = 'none',
}

export enum CancelPaymentRequestReason {
  Default = '',
  ConnectedToFacilitator = 'Don’t feel connected to my facilitator',
  ConnectedToCircle = 'Don’t feel connected to my Circle',
  MeetingTimeNotGood = 'Day or hour are not a good fit',
  PreferTherapy = 'Prefer 1:1 therapy',
  TechnicalIssues = 'Technical issues',
  PreferLocalSupportGroup = 'Prefer local support group',
  FinancialReasons = 'It’s too expensive',
  ReadyToMoveOn = 'I’m ready to move on',
  NotReadyToStart = 'I’m not ready to start',
  DoNotHaveTime = 'I have a busy schedule',
  Other = 'Other',
}

export enum CancelPaymentRequestStatus {
  New = 'new',
  ReEnabled = 're-enabled',
  Approved = 'approved',
}

export type CancelPaymentRequest = {
  status: CancelPaymentRequestStatus;
  timestamp: number;
};

export type PrivateGroup = {
  groupInstanceId: string; // deprecated, replaced by channelId
  channelId: string;
  peerId: string;
  type: StreamChannelType.Private | StreamChannelType.Dm | StreamChannelType.Circles;
};

export type IapPurchasesHistory = {
  purchasedAt: string;
  status: string;
};

export enum SessionTimePreferences {
  Morning = 'morning',
  Afternoon = 'afternoon',
  Evening = 'evening',
}

export interface Event {
  id: string;
  type: 'event' | 'one-time-circle';
  title: string | null;
  segment: string | null;
  status: 'active' | 'inactive' | 'pending' | 'locked' | 'supervisor' | 'ghost';
  cta: string | null;
  externalUrl: string | null;
  meta: Record<string, unknown>;
  lastUpdated: string;
  dateCreated: string;
}

export type Account = {
  id: string | null;
  fullName: string;
  name: string | null; // deprecated, replaced by nickname
  nickname: string | null;
  phoneNumber: string | null;
  role: AccountRole | null;
  email: string | null;
  picture: string | null; // deprecated, replaced by imageUrl
  imageUrl: string | null;
  status: AccountStatus | null;
  segment: string | null;
  lastUpdated: string | null;
  timezone: string | null;
  firebaseIds: string[];
  meta: any | null;
  isPayment: boolean;
  paymentTimestamp: number | null;
  subscriptionStatus: string | null;
  paymentProvider: string | null;
  trialEnd: string | null;
  cancelPaymentRequest: CancelPaymentRequest | null;
  firstSession: number | null;
  firstAvailableMeeting: number | null;
  privateGroups: Record<string, PrivateGroup>;
  voiceGuide: boolean;
  iapPurchasesHistory?: Record<string, IapPurchasesHistory>;
  tagline: string;
  socialLinks: Array<{ type: string; url: string }>;
  optOutCommunication: boolean;
  bannedGuides: string[];
};

export type AccountProfileProperties = {
  name: string; // deprecated, replaced by nickname
  nickname: string;
  picture: string; // deprecated, replaced by imageUrl
  imageUrl: string;
  passions: Array<AccountsTag['key']>;
  descriptionTags: Array<AccountsTag['key']>;
  intro: string;
  whatBringsMe: string;
};

export interface HubSpotTicketFromApiProps {
  subject: string;
  content: string;
  sourceType: HubspotSourceType;
  hubspotIssueType: HubSpotIssueType;
  pipeline: number;
}

export enum HubSpotIssueType {
  TechnicalIssue = 'Technical Issue',
  CancellationRequest = 'Cancelation request',
  GroupPlacement = 'Group placement',
  DeleteAccount = 'Delete account',
  DuplicateSubscription = 'Duplicate subscription',
  ContactUs = 'Contact Us',
}
